import { Action, handleActions } from 'redux-actions';
import {
  AUTH_SET_USER_DATA,
  AUTH_SET_USER_SIGNED_OUT,
  AUTH_SIGN_OUT,
} from './constants/ActionTypes';
import { AuthState, IAuthState } from './model';

const initialState: IAuthState = {
  authState: AuthState.Unknown,
  busy: false,
};

export default handleActions<IAuthState>(
  {
    [AUTH_SIGN_OUT]: (state: IAuthState): IAuthState => {
      return { ...state };
    },

    [AUTH_SET_USER_DATA]: (state: IAuthState): IAuthState => {
      const newState = {
        authState: AuthState.Authenticated,
        busy: false,
      };
      return newState;
    },

    [AUTH_SET_USER_SIGNED_OUT]: (
      state: IAuthState,
      action: Action<any>
    ): IAuthState => {
      return {
        ...state,
        authState: AuthState.NotAuthenticated,
        busy: false,
      };
    },
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/auth/reducer.ts